import React from 'react';
import { Dialog } from '@chakra-ui/react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  size?: string;
  children: React.ReactNode;
}

export function Modal({ isOpen, onClose, size = 'md', children }: ModalProps) {
  return (
    <Dialog.Root 
      open={isOpen} 
      onOpenChange={(details) => {
        if (!details.open) {
          onClose();
        }
      }}
      size={size}
      lazyMount
      unmountOnExit
    >
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content>
          {children}
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
}

export const ModalOverlay = () => null; // Already rendered in Modal component
export const ModalContent = ({ children }: { children: React.ReactNode }) => <>{children}</>;
export const ModalHeader = ({ children }: { children: React.ReactNode }) => (
  <Dialog.Header>
    <Dialog.Title>{children}</Dialog.Title>
  </Dialog.Header>
);
export const ModalCloseButton = Dialog.CloseTrigger;
export const ModalBody = Dialog.Body;
export const ModalFooter = Dialog.Footer;